import { combineReducers } from 'redux'
import edit from './edit.reducer'

export default combineReducers({
  edit
})
